<template>
  <div class="md-layout p-15px">
    <template v-if="$route.name !== 'home_wiki'">
      Tổng hợp các hạng mục kiến thức
    </template>
  </div>
</template>

<script>

export default {
  components: {
  },

  data() {
    return {
    };
  },

  methods: {
  }
};
</script>
